module.exports = __webpack_public_path__ + "static/img/right-num-row-2.f7b9d059.png";